import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface SystemResetSummaryDTO {
  paymentLinkAssociations: number;
  paymentLinks: number;
  excessPayments: number;
  incomeReceipts: number;
  incomeFeeDetails: number;
  paymentPlans: number;
  expenseVouchersItems: number;
  expenseFeeDetails: number;
  expenseVouchers: number;
  workOrderItems: number;
  workOrders: number;
  corporateEnrollmentParticipants: number;
  corporateEnrollmentAgreements: number;
  enrollments: number;
  totalRecords: number;
}

export interface SystemResetResponseDTO {
  success: boolean;
  message: string;
  deletedRecords: SystemResetSummaryDTO;
  executionTime: string;
  executedAt: string;
  details: string[];
  warnings: string[];
}

@Injectable({
  providedIn: 'root'
})
export class SystemResetService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "SystemReset"
  }

  /**
   * Obtiene el resumen de datos que serán eliminados en el reset
   */
  getResetSummary(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/summary`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * Ejecuta el reset del sistema con la clave de confirmación
   * @param confirmationKey - Clave de confirmación requerida
   * @param dryRun - Si es true, solo simula el reset sin eliminar datos
   */
  resetSystem(confirmationKey: string, dryRun: boolean = false): Observable<any> {
    const payload = { confirmationKey, dryRun };
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}/execute`, payload)
      .pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrió un error", error.error.message);
    } else {
      console.log(`Ocurrió un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
